import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect} from "react-router-dom";
import { withTranslation } from "react-i18next";
import Shop from "./Shop";
import ShopProduct from "./ShopProduct/ShopProduct";
import ShopCart from "./ShopCart/ShopCart";
import ShopValidation from "./ShopValidation/ShopValidation";
import { SentryRoute } from "index";

class ShopRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToHome: false,
    };
  }

  componentDidMount() {
    this.shouldRedirect();
  }
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      this.shouldRedirect();
    }
  }

  shouldRedirect = () => {
    const {
      account: {
        validated = true,
        baGiftshop = true,
        ongoingSessions = false,
        upcomingSessions = false,
      },
      config: { shopEnabled = true },
    } = this.props;

    if (
      !shopEnabled ||
      !validated ||
      !baGiftshop ||
      !(ongoingSessions || upcomingSessions)
    ) {
      this.setState({ redirectToHome: true });
    } else {
      this.setState({ redirectToHome: false });
    }
  };

  render() {
    const { match, location } = this.props;
    const { redirectToHome } = this.state;

    if (redirectToHome) {
      return <Redirect to="/" />;
    }

    return (
      <Fragment>
        <Switch location={location}>
          <SentryRoute exact path={`${match.path}`} component={Shop} />
          <SentryRoute
            exact
            path={`${match.path}/product/:id`}
            component={ShopProduct}
          />
          <SentryRoute exact path={`${match.path}/cart`} component={ShopCart} />
          <SentryRoute
            exact
            path={`${match.path}/cart/order=:number`}
            component={ShopValidation}
          />
          <SentryRoute component={Shop} />
        </Switch>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
});

export default withTranslation()(connect(mapStateToProps)(ShopRouter));
